<div class="mt-2 mt-sm-3 pt-2 pt-sm-3 border-top" @click.stop>
  <div class="p-0">
    <div class="d-flex align-items-center justify-content-between gap-2 pb-2 mb-2 mb-sm-3 text-primary">
      <span class="d-inline-flex align-items-center gap-1 gap-sm-2">
        <i class="bi bi-chat-dots-fill"></i>
        <span class="text-xxs fw-bold">Comments</span>
      </span>
      <span class="d-inline-flex align-items-center gap-1 text-xxs text-muted fw-semibold">
        {{ comment_count }} <i class="bx bxs-comment"></i>
      </span>
    </div>

    <div class="mb-2 mb-sm-3 mt-2">
      <form @submit.prevent="post_comment">
        <div class="input-group border bg-white rounded-5 shadow-sm overflow-hidden p-1">
          <input
            v-model="comment_text"
            class="form-control comment-input border-0 bg-transparent text-xxs py-1 px-3"
            placeholder="Write a comment..."
            @keyup.enter.prevent="post_comment"
          />

          <button
            class="btn btn-primary rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 comment-send-button border-0"
            type="submit"
            :disabled="is_posting_comment">
            <span v-if="is_posting_comment" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i v-else class="bi bi-send"></i>
          </button>
        </div>
      </form>
    </div>

    <div v-for="comment in comments" :key="comment.id" class="mb-2 mb-sm-3">
      <div class="d-flex align-items-start gap-1 gap-sm-2 p-1 p-sm-2 rounded-3 bg-light border">
        <img
          :src="comment.created_by?.profile_type === 'personal'
                  ? (get_personal_profile_picture(comment?.created_by?.user?.profile?.profile_files ))
                  : (comment?.created_by?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
          loading="lazy"
          class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
        />
        <div class="w-100 min-w-0">
          <div class="d-flex justify-content-between align-items-start gap-2">
            <strong class="text-xxs text-dark fw-bold text-break min-w-0">
              {{ comment.is_blocked ? "Unknown User" : comment.created_by_name }}
            </strong>
            <small class="text-muted text-xxs flex-shrink-0 text-nowrap"><span>{{ time_ago(comment.date_created) }}</span></small>
          </div>
          <p class="mb-1 mt-2 text-xxs text-dark text-break overflow-wrap-anywhere d-md-none">
            {{ should_truncate_text(comment.comment_text) && !is_comment_expanded(comment.id)
              ? get_truncated_text(comment.comment_text)
              : comment.comment_text }}
          </p>
          <p class="mb-1 mt-2 text-xxs text-dark text-break overflow-wrap-anywhere d-none d-md-block">
            {{ comment.comment_text }}
          </p>
          <button
            v-if="should_truncate_text(comment.comment_text)"
            type="button"
            class="btn btn-link text-xxs text-decoration-none p-0 mb-1 d-md-none"
            @click="toggle_comment_expanded(comment.id)"
          >
            {{ is_comment_expanded(comment.id) ? 'See less' : 'See all' }}
          </button>
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm btn-link text-decoration-none p-0 text-xxs"
              @click="reply_comment_id = (reply_comment_id === comment.id ? null : comment.id)"
            >
              <i class="bi bi-reply"></i>
              {{ reply_comment_id === comment.id ? 'Hide replies' : 'Reply' }}
              <span v-if="comment.reply_count">({{ comment.reply_count }})</span>
            </button>
          </div>
          <form action="">
            <div class="input-group border bg-white rounded-5 shadow-sm overflow-hidden mt-2" v-if="reply_comment_id === comment.id">
              <input type="text" v-model="reply_text" @keyup.enter="reply_to_comment(comment.id)"
                    class="form-control comment-input border-0 bg-transparent text-xxs py-1 px-3"
                    placeholder="Write your reply ..."/>
              <button class="btn btn-primary px-2 py-1 border-0" type="button" @click="reply_to_comment(comment.id)" :disabled="posting_reply_comment_id === comment.id">
                <span
                  v-if="posting_reply_comment_id === comment.id"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i v-else class="bi bi-send"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div v-if="comment.replies?.length && reply_comment_id === comment.id" class="ms-3 ms-sm-4 mt-2 ps-2 ps-sm-3 border-start">
        <div
          v-for="reply in comment.replies"
          :key="reply.id"
          class="d-flex align-items-start gap-1 gap-sm-2 mb-2 p-1 p-sm-2 rounded-3 bg-white border"
        >
          <img
            :src="reply.created_by?.profile_type === 'personal'
                    ? (get_personal_profile_picture(reply?.created_by?.user?.profile?.profile_files))
                    : (reply?.created_by?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
            loading="lazy"
            class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
          />
          <div class="w-100 min-w-0">
            <div class="d-flex justify-content-between align-items-start gap-2">
              <strong class="text-xxs text-dark fw-bold text-break min-w-0">
                {{ reply.is_blocked ? "Unknown User" : reply.created_by_name }}
              </strong>
              <small class="text-muted text-xxs flex-shrink-0 text-nowrap">{{ time_ago(reply.date_created) }}</small>
            </div>
            <p class="mb-1 mt-2 text-xxs text-dark text-break overflow-wrap-anywhere d-md-none">
              {{ should_truncate_text(reply.reply_text) && !is_reply_expanded(reply.id)
                ? get_truncated_text(reply.reply_text)
                : reply.reply_text }}
            </p>
            <p class="mb-1 mt-2 text-xxs text-dark text-break overflow-wrap-anywhere d-none d-md-block">
              {{ reply.reply_text }}
            </p>
            <button
              v-if="should_truncate_text(reply.reply_text)"
              type="button"
              class="btn btn-link text-xxs text-decoration-none p-0 d-md-none"
              @click="toggle_reply_expanded(reply.id)"
            >
              {{ is_reply_expanded(reply.id) ? 'See less' : 'See all' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
